import React, { memo } from 'react';
import {
    ThemeProvider as AckoThemeProvider,
    AckoMainTheme,
} from '@acko-tech/building-blocks.ui.theme';

import {
    $primaryColors,
    $fontWeightLight,
    $fontWeightNormal,
    $fontWeightBold,
    $fontWeightBolder,
    createGlobalStyle,
    ThemeProvider,
} from '@acko-tech/building-blocks.ui.common';

import { computeSpacing } from 'Utils/styles';

const $fontFamily =
    "'Inter', 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";
function Theme({ children }: Props): JSX.Element {
    const themeVariables = {
        primaryColor: $primaryColors,
        fontFamily: $fontFamily,
        lightWeight: $fontWeightLight,
        normalWeight: $fontWeightNormal,
        boldWeight: $fontWeightBold,
        bolderWeight: $fontWeightBolder,
        selected: $primaryColors.normal,
        selectedText: '#151619',
        default: '#8990a1',
        spacing: computeSpacing,
        color: {
            textBlack: '#414A53',
            buttonGrey: '#F3F7FF',
        },
        borderRadius: 4,
    };

    return (
        <AckoThemeProvider theme={AckoMainTheme}>
            <>
                <ThemeProvider theme={themeVariables}>{children}</ThemeProvider>
            </>
        </AckoThemeProvider>
    );
}

interface Props {
    children: JSX.Element;
}

export default memo(Theme);

export const GlobalStyles = createGlobalStyle`
    body {
        font-family: ${$fontFamily};
        background-color: #F4F5F7;
        margin: 0;
        height: 100%;
        color: ${(props: any) => props.theme.color.textBlack}
    }

    html {
        height: 100%;
        scroll-behavior: smooth;
    }

    #__next {
        height: 100%;
    }

    * {
        box-sizing: border-box;
    }
`;
